__turbopack_context__.v({
  "container": "LjlCrq_container",
  "item": "LjlCrq_item",
});
